import React, { useEffect, useState } from "react";
import { images } from "../../constants";
import { Logo, NavBarContainer, NavLink } from "./Navbar.styled";

const NavBar = () => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 32);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <NavBarContainer hasScrolled={hasScrolled}>
      <NavLink href="/about">About</NavLink>
      <NavLink href="/home">
        <Logo src={images.logo} alt="logo" height="70" />
      </NavLink>
      <NavLink href="/">Our App</NavLink>
    </NavBarContainer>
  );
};

export default NavBar;
